export var styles = {
    body: {
        // height: 500,
        // boxShadow: '0 2px 10px 0 rgba(0,0,0,.17)',
        borderRadius: 5,
    },
    tncContaniner: {
        background: 'white',
        padding: '16px 32px 16px 16px',
        overflow: 'hidden',
        height: 400,
        border: '1px solid #D2D5DA',
        borderRadius: 5,
    },
};
